"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapV3Connector = void 0;
const UniswapV3Connector_1 = __importDefault(require("../../abis/teleswap/UniswapV3Connector"));
const contract_base_1 = __importDefault(require("../contract-base"));
class UniswapV3Connector extends contract_base_1.default {
    constructor(connectionConfig, contractAddress) {
        super(connectionConfig, contractAddress, UniswapV3Connector_1.default);
    }
    isPathValid(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.isPathValid(path).call();
        });
    }
    getExactInput(path, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.getExactInput(path, amount).call();
        });
    }
    getExactOutput(path, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.getExactOutput(path, amount).call();
        });
    }
}
exports.UniswapV3Connector = UniswapV3Connector;
exports.default = UniswapV3Connector;
//# sourceMappingURL=uniswap-v3-connector-interface.js.map